/*
 * Public API Surface of header
 */

export * from './lib/header.module';
export * from './lib/header.component';
